// extracted by mini-css-extract-plugin
export default {"pagination":"style_pagination__EC6aX","pageNumber":"style_pageNumber__-z+rV","pageActive":"style_pageActive__YtCcc"};